import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { FormatUtils, PaletteUtils } from '@shared/utils';
import { Popup } from '@shared/widgets';
import CloseIcon from '@assets/icons/messages/close.svg';

interface MobileItemViewProps {
  onClose: () => void;
  transaction: any;
  account: any;
}

export const MobileItemView = (props: MobileItemViewProps) => {
  const { t } = useTranslation('card');

  return (
    <Popup open onClose={props.onClose}>
      <div className='w-[calc(100%-40px)] max-h-[calc(100%-40px)] rounded-sm bg-[#fcfcfc] p-[20px_30px] text-right m-auto mt-5'>
        <div className='flex justify-end'>
          <CloseIcon onClick={() => props.onClose()} className={clsx(PaletteUtils.isBordierPalette ? 'text-[#dc291c]' : 'text-[#BE8B45]')} />
        </div>

        <div className='overflow-y-auto'>
          <ul className='m-0 p-0 list-none'>
            <li className='block mb-5 text-base font-medium text-left text-[#6b6b70]'>
              <span>{t('transactions.mobileItem.fields.date')}:</span>
              <span className='block mt-0.5 text-lg font-semibold text-left text-[#25252a]'>
                {FormatUtils.formatDate(props.transaction.postingDate)}
              </span>
            </li>
            <li className='block mb-5 text-base font-medium text-left text-[#6b6b70] border-b border-[#c3c3c4] pb-[22px]'>
              <span>{t('transactions.mobileItem.fields.description')}:</span>
              <span className='block mt-0.5 text-lg font-semibold text-left text-[#25252a]'>{props.transaction.description}</span>
            </li>
            <li className='block mt-7 mb-5 text-base font-medium text-left text-[#6b6b70]'>
              <span>{t('transactions.mobileItem.fields.reference')}:</span>
              <span className='block mt-0.5 text-lg font-semibold text-left text-[#25252a]'>{props.transaction.transactionId || '-'}</span>
            </li>
            <li className='block mb-5 text-base font-medium text-left text-[#6b6b70]'>
              <span>{t('transactions.mobileItem.fields.card')}:</span>
              <span className='block mt-0.5 text-lg font-semibold text-left text-[#25252a]'>
                {FormatUtils.formatCardNumber(props.transaction.cardLastFourDigits)}
              </span>
            </li>
            <li className='block mb-5 text-base font-medium text-left text-[#6b6b70]'>
              <span>{t('transactions.mobileItem.fields.localCurrency')}:</span>
              <span className='block mt-0.5 text-lg font-semibold text-left text-[#25252a]'>
                {FormatUtils.formatAmount(props.transaction.originalAmount, props.transaction?.originalCurrency)}
              </span>
            </li>
            <li className='block mb-5 text-base font-medium text-left text-[#6b6b70]'>
              <span>{t('transactions.mobileItem.fields.amountIn', { currency: props.account?.currency?.toUpperCase() })}:</span>
              <span className='block mt-0.5 text-lg font-semibold text-left text-[#25252a]'>
                {FormatUtils.formatAmount(props.transaction.totalAmount, props.account?.currency)}
              </span>
            </li>
            {props.transaction.feesDescription?.map((fee: any, index: number) => (
              <li key={index} className='block mb-5 text-base font-medium text-left text-[#6b6b70]'>
                <span>{t('transactions.mobileItem.fields.feesDescription')}:</span>
                <span className='block mt-0.5 text-lg font-semibold text-left text-[#25252a]'>{fee}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </Popup>
  );
};
